import { Icon, Space, SubText, TextLabel } from '@procurify/ui'
import { capitalize } from 'lodash'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type AuditLogChangedField } from '../../entities/AuditLogChangedField'

type valueType = 'from' | 'to'

export interface IAuditLogRecordChangeProps {
  field: AuditLogChangedField['field']
  from?: AuditLogChangedField['from']
  to: AuditLogChangedField['to']
}

export const getColorForValueType = (valueType: valueType) => {
  switch (valueType) {
    case 'from':
      return 'textSecondary'
    case 'to':
    default:
      return 'textPrimary'
  }
}

export const AuditLogRecordChange = ({
  field,
  from,
  to,
}: IAuditLogRecordChangeProps) => {
  const intl = useProcurifyIntl()

  const formatValue = (
    value: AuditLogChangedField['from'],
    valueType: valueType
  ) => {
    const textColor = getColorForValueType(valueType)

    if (Array.isArray(value)) {
      if (value.length === 0)
        return (
          <SubText bold color={textColor}>
            {intl.formatMessage(messages.noneLabel)}
          </SubText>
        )

      return (
        <ul>
          {value.map((item, index) => (
            <li key={index}>
              <SubText bold color={textColor}>
                {item}
              </SubText>
            </li>
          ))}
        </ul>
      )
    }
    return (
      <SubText bold color={textColor}>
        {value}
      </SubText>
    )
  }

  return (
    <>
      <TextLabel id={`${field}-label`}>{capitalize(field)}</TextLabel>

      <div aria-labelledby={`${field}-label`}>
        <Space direction='horizontal' align='center' size='small'>
          {!!from && (
            <Space direction='horizontal' align='center' size='small'>
              {formatValue(from, 'from')}
              <Icon icon='pointer-right' />
            </Space>
          )}
          {formatValue(to, 'to')}
        </Space>
      </div>
    </>
  )
}
